<!-- Toast Messages -->
<p-toast
  data-testid="virtual-warehouse-list-toast"
  position="top-right"
  [baseZIndex]="9999"
  [autoZIndex]="true"
  [life]="4000"
  [preventDuplicates]="false"
></p-toast>

<div data-testid="virtual-warehouse-list-page" class="px-6 pt-6 flex-table-page">
  <!-- Header -->
  <h2 class="text-2xl font-semibold text-gray-800 mb-3 flex-table-header">
    {{ "virtual_warehouse.management.title" | translate }}
  </h2>

  <app-search-form
    data-testid="virtual-warehouse-list-search-form"
    [searchFormat]="searchConfig()"
    (formSearch)="onSearch($event)"
    (formReset)="onReset()"
  >
    <div slot="actions" class="flex gap-2">
      <app-button
        [testId]="'virtual-warehouse-list-column-config-btn'"
        type="success"
        [outlined]="true"
        icon="view_column"
        (emitOnClick)="onColumnConfigClick($event)"
      ></app-button>
      <app-status-filter
        [primaryButton]="primaryButton()"
        (primaryButtonClick)="onAddWarehouse()"
      ></app-status-filter>
    </div>
  </app-search-form>

  <!-- Data Table -->
  <div class="flex-table-section">
    <advanced-data-table
      data-testid="virtual-warehouse-list-table"
      #advancedTable
      [dataSource]="warehousesData()"
      [defaultColumns]="defaultColumns()"
      [flexibleColumns]="flexibleColumns()"
      [loading]="loading()"
      [rows]="searchParams().size"
      [first]="searchParams().page * searchParams().size"
      [totalRecords]="totalRecords()"
      [hasCheckColumn]="false"
      [showInternalColumnConfigButton]="false"
      scrollHeight="flex"
      (pageChange)="onPageChange($event)"
      class="w-full"
    >
    <!-- Custom Template for cityName, memberWarehouses and date -->
    <ng-template
      #customTemplate
      let-value
      let-rowData="rowData"
      let-column="column"
    >
      @if (column && column.template === "dateTemplate") {
        <span class="text-xs text-gray-600">
          {{ formatDateTime(value) }}
        </span>
      } @else if (column && column.template === "cityNameTemplate") {
        <span
          class="text-xs text-gray-700 block truncate"
          [pTooltip]="getTranslatedCityName(value)"
          tooltipPosition="top"
          tooltipStyleClass="custom-tooltip"
          [showDelay]="300"
          [hideDelay]="0"
        >
          {{ getTranslatedCityName(value) }}
        </span>
      } @else if (column && column.template === "memberWarehousesTemplate") {
        <span
          class="text-xs text-gray-700 block truncate"
          [pTooltip]="formatMemberWarehouses(value)"
          tooltipPosition="top"
          tooltipStyleClass="custom-tooltip"
          [showDelay]="300"
          [hideDelay]="0"
        >
          {{ formatMemberWarehouses(value) }}
        </span>
      } @else {
        {{ value }}
      }
    </ng-template>

    <!-- Custom Status Template -->
    <ng-template #statusTemplate let-status let-rowData="rowData">
      <div class="flex items-center justify-center gap-1">
        <p-tag
          data-testid="virtual-warehouse-list-status-tag"
          [value]="getStatusDisplayText(rowData.status)"
          [severity]="getStatusSeverity(rowData.status)"
          styleClass="status-tag"
          [ngStyle]="getStatusStyle(rowData.status)"
          pTooltip="{{
            rowData.status
              ? ('virtual_warehouse.status.active' | translate)
              : ('virtual_warehouse.status.inactive' | translate)
          }}"
          tooltipPosition="top"
          tooltipStyleClass="custom-tooltip"
          [showDelay]="300"
          [hideDelay]="0"
        />
      </div>
    </ng-template>

    <!-- Custom Actions Template -->
    <ng-template #actionsTemplate let-rowData>
      <div class="flex items-center gap-2 justify-center">
        @if (canUpdate()) {
          <app-button
            [testId]="'virtual-warehouse-list-action-edit-' + rowData.id"
            class="action-edit"
            [label]="'virtual_warehouse.actions.edit' | translate"
            type="action"
            (emitOnClick)="onEdit(rowData)"
          ></app-button>
        }
        @if (canApprove()) {
          <app-button
            [testId]="
              'virtual-warehouse-list-action-' +
              (rowData.status ? 'deactivate' : 'activate') +
              '-' +
              rowData.id
            "
            [class]="rowData.status ? 'action-disable' : 'action-enable'"
            [label]="
              rowData.status
                ? ('virtual_warehouse.actions.deactivate' | translate)
                : ('virtual_warehouse.actions.activate' | translate)
            "
            type="action"
            (emitOnClick)="onStatusChange(rowData)"
          ></app-button>
        }
        @if (canDelete() && !rowData.status) {
          <app-button
            [testId]="'virtual-warehouse-list-action-delete-' + rowData.id"
            class="action-delete"
            [label]="'virtual_warehouse.actions.delete' | translate"
            type="action"
            (emitOnClick)="onDelete(rowData)"
          ></app-button>
        }
      </div>
    </ng-template>
    </advanced-data-table>
  </div>

  <!-- Shared Confirmation Dialog -->
  <app-confirmation-dialog
    data-testid="virtual-warehouse-list-confirmation-dialog"
    [(visible)]="showConfirmationDialog"
    [title]="dialogTitle"
    [message]="dialogMessage"
    [buttons]="dialogButtons"
    (emitOnClick)="onConfirmatiButtonClick($event)"
  ></app-confirmation-dialog>
</div>
